import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select'; 
import { Button, ButtonGroup } from '@/shared/components/Button';
import { Form, InputGroup } from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import { FaExclamationCircle } from 'react-icons/fa';
import RejectCard from './RejectCard';
import { AuthContext } from '../../../../../context/AuthContext';
import ProgressBar from '../../../Loader';
import { SideBarRefreshContext } from '../../../../../context/SideBarRefreshContext';

const Reject = () => {
    const { apiGlobal } = useContext(AuthContext);
    const { sideBarRefresh } = useContext(SideBarRefreshContext); 
    const [bookingData, setBookingData] = useState([]);
    const [filteredBookingData, setFilteredBookingData] = useState([]);
    const [tripOption, setTripOption] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [refresh, setRefresh] = useState(false);
    const [searchStartDate, setSearchStartDate] = useState('');
    const [searchEndDate, setSearchEndDate] = useState('');

    // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 3;

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = Array.isArray(filteredBookingData)
  ? filteredBookingData.slice(indexOfFirstItem, indexOfLastItem)
  : [];


  // Total pages should be based on filteragent length, not agent
  const totalPages = Math.ceil(filteredBookingData.length / itemsPerPage);
  
    useEffect(() => {
      const fetchRejectBookingData = async () => {
        setIsLoading(true);
        try {
          const response = await fetch(`${apiGlobal}booking_reject_list.php`, {
            method: 'POST',
          });
          const data = await response.json();
          if (data.status && data.message) {
            setBookingData(data.data);
            setFilteredBookingData(data.data);
            const tripOptions = data.data.map(trip => ({
              value: trip.id,
              label: `${trip.name } (${trip.trip_uin})`, 
            }));
            setTripOption(tripOptions);
           } else {
            setBookingData({});
           }
        } catch (error) {
          console.error(error);
        } finally {
          setIsLoading(false);
        }
      };
    
      fetchRejectBookingData();
    }, [refresh, sideBarRefresh?.adminBookingRefresh]);

    const filterBookingHandler = (selectedOption) => {
      setSelectedTrip(selectedOption); // Update selected trip
    
      if (!selectedOption) {
        setFilteredBookingData(bookingData); // Reset filter when no trip is selected
        return;
      }
    
      // Filter booking data based on selected trip ID
      const filteredData = bookingData.filter(trip => trip.id === selectedOption.value);
      setFilteredBookingData(filteredData);
    };


        // Filter Data Based on Date Range
  useEffect(() => {
    let filteredData = [...bookingData];

    if (searchStartDate) {
      filteredData = filteredData.filter((trip) => {
        const tripStartDate = new Date(trip?.start_date);
        return tripStartDate >= new Date(searchStartDate);
      });
    }

    if (searchEndDate) {
      filteredData = filteredData.filter((trip) => {
        const tripEndDate = new Date(trip?.end_date);
        return tripEndDate <= new Date(searchEndDate);
      });
    }

    setFilteredBookingData(filteredData);
  }, [searchStartDate, searchEndDate, bookingData]);


   // use Effect to add keyframes for the pulse animation
   useEffect(() => {
    // Add keyframes via JavaScript when component mounts
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes pulse {
        0% { transform: scale(1); opacity: 1; }
        50% { transform: scale(1.2); opacity: 0.8; }
        100% { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }, []);


    if (isLoading) {
      return (
        <div
          style={{
            display: 'flex',
            // justifyContent: 'center', // Center horizontally
            // alignItems: 'center', // Center vertically
            height: '100vh', // Full viewport height
          }}
        >
          <ProgressBar />
        </div>
      );
    }
    
  return (
    <div>
      {/* <Select
        name="tripName"
        className="react-select w-25 mb-4"
        classNamePrefix="react-select"
        options={tripOption}
        isClearable
        value={selectedTrip}
        placeholder="Select a trip"
        onChange={filterBookingHandler}
      /> */}
      <div
        className="mb-4"
        style={{
          padding: '15px',
          borderRadius: '8px',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '10px',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        <Select
          name="tripName"
          className="react-select w-25 mb-4 mt-3"
          classNamePrefix="react-select"
          options={tripOption}
          isClearable
          value={selectedTrip}
          placeholder="Select a trip"
          onChange={filterBookingHandler}
        />
        <ButtonGroup icons dir="ltr" className="mt-2">
          <Button
            variant="outline-secondary"
            className=""
            title="Refresh"
            size="sm"
            onClick={() => setRefresh(prev => !prev)}
          >
            <span className="lnr lnr-sync text-primary" />
          </Button>
        </ButtonGroup>
        {/* Search Filters */}
        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="Start Date"
            value={searchStartDate}
            onChange={e => setSearchStartDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <InputGroup className="mb-2" style={{ maxWidth: '160px' }}>
          <Form.Control
            type="date"
            placeholder="End Date"
            value={searchEndDate}
            onChange={e => setSearchEndDate(e.target.value)}
            style={{
              borderRadius: '25px',
              padding: '8px',
              border: '1px solid #ddd',
            }}
          />
        </InputGroup>

        <Button
          variant="outline-danger"
          style={{
            borderRadius: '25px',
            padding: '8px 16px',
            marginLeft: '10px',
            alignSelf: 'center',
          }}
          className="mt-3"
          onClick={() => {
            setSearchStartDate('');
            setSearchEndDate('');
          }}
        >
          Clear Filters
        </Button>
      </div>

      <div>
        {filteredBookingData.length > 0 ? (
               currentItems.map(booking => (
                 <RejectCard 
                   key={booking.id}
                   bookingData={booking}
                 />
               ))
             ) : (
               <div style={{
                textAlign: 'center',
    padding: '50px',
    backgroundColor: '#f8d7da',
    borderRadius: '8px',
    marginTop: '20px',
                color: '#721c24',
    fontSize: '16px',
              }}
               >
                 <div
                   style={{
fontSize: '48px',
marginBottom: '20px',
color: '#e63946',
animation: 'pulse 1.5s infinite ease-in-out',
display: 'inline-block',
}}
                 >
                   <FaExclamationCircle />
                 </div>
                 <p>No Past booking available</p>
               </div>
             )}
      </div>
      {/* Pagination Controls */}
      <div
        style={{
          // position: 'fixed', 
          bottom: '20px', 
          right: '20px', 
          zIndex: 999, 
          display: 'flex', 
          justifyContent: 'flex-end', 
          alignItems: 'center',
        }}
      >
        {filteredBookingData.length > 0 && (
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {Array.from({ length: totalPages }, (_, index) => (
            <Pagination.Item
              key={index + 1}
              active={index + 1 === currentPage}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </Pagination.Item>
 ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
        )}
       
      </div>
    </div>
    );
};



export default Reject;
